import { GlobalAxios } from "../axios/axios-config";
import {
  IMarComAutomationLists,
  INewMarComAutomationLists,
} from "../models/mar-com-automation-list";

const CAMPAIGN_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationList";

export const createMarComAutomationList = (
  params: INewMarComAutomationLists
) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getMarComAutomationListById = (id: string) => {
  return GlobalAxios.get<IMarComAutomationLists>(CAMPAIGN_ROUTE + "/" + id);
};

export const updateMarComAutomationList = ({
  id,
  item,
}: {
  id: string;
  item: INewMarComAutomationLists;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + "/" + id, item);
};
